const is_tem_fix = typeof window.AC === "undefined";
let api_url,
  root_url,
  assets_url,
  basename,
  activecollab_url,
  activecollab_site_url,
  activecollab_site_url_login,
  instance,
  new_frontend_url,
  is_next_primary;

//todo remove this after build AC 7.5.900 and leave only else case when released to stable
if (is_tem_fix) {
  const url = new URL(window.location);
  const pathnameArr = url.pathname.split("/");

  let instanceId = parseInt(pathnameArr[1]);

  instanceId = Number.isInteger(instanceId) ? instanceId : 0;

  let hostAndPort = [process.env.HOST];

  if (process.env.PORT) {
    hostAndPort.push(process.env.PORT);
  }
  const protocolPart = process.env.PROTOCOL ? `${process.env.PROTOCOL}:/` : null;
  const baseParts = [protocolPart, hostAndPort.join(":")].filter((part) => part !== null);
  const apiUrlParts = [...baseParts];
  const rootUrlParts = [...baseParts];

  if (instanceId > 0) {
    apiUrlParts.push(instanceId);
    rootUrlParts.push(instanceId);
  }

  apiUrlParts.push(process.env.API_PATH);

  const assetsUrlParts = [...baseParts, "assets"];
  api_url = `${apiUrlParts.join("/")}`;
  root_url = `${rootUrlParts.join("/")}`;
  assets_url = `${assetsUrlParts.join("/")}`;
  basename = instanceId > 0 ? `/${instanceId}` : "";
  activecollab_url = `${process.env.ACTIVECOLLAB_URL}${basename}`;
  activecollab_site_url = process.env.SHEPHERD_URL ? `${process.env.SHEPHERD_URL}` : "https://activecollab.com";
  activecollab_site_url_login = `${activecollab_site_url}/login`;
  instance = instanceId > 0 ? instanceId : null;
} else {
  api_url = window.AC.api_url;
  root_url = window.AC.root_url;
  assets_url = window.AC.assets_url;
  basename = window.AC.basename ? window.AC.basename : "";
  activecollab_url = process.env.ACTIVECOLLAB_URL ? `${process.env.ACTIVECOLLAB_URL}${basename}` : root_url;
  activecollab_site_url = process.env.SHEPHERD_URL ? `${process.env.SHEPHERD_URL}` : "https://activecollab.com";
  activecollab_site_url_login = `${activecollab_site_url}/login`;
  instance = window.AC.instance_id ? window.AC.instance_id : null;
  new_frontend_url = window.AC.new_frontend_url ? window.AC.new_frontend_url : null;
  is_next_primary = window.AC.is_next_primary ?? false;
}

export {
  api_url,
  root_url,
  assets_url,
  basename,
  activecollab_url,
  activecollab_site_url,
  activecollab_site_url_login,
  instance,
  new_frontend_url,
  is_next_primary,
};
